// extracted by mini-css-extract-plugin
export default {"nativeShare":"dlW_5","linkCopyContainer":"zdDFO","linkCopyInputContainer":"E0VZ1","linkCopyInput":"bEZoi","linkButton":"e0n43","buttonIcon":"OF9Im","buttons":"tDN7J"};